/**
     * @desc //13开启我的盲盒
用于：个人盲盒页面
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/box/openMyBox', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/box/openMyBox', params);
}
